import React, { useEffect, useState, useCallback, useMemo } from "react";
import { callApiAsync, getBillingSelect } from "../../services/apiService";
import icons from "../../constants/icons";
import Grid from "@mui/material/Grid2";
import SearchableSelectInput from "../../components/selectInput/searchableSelectInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TableAddittionalCost from "../../components/tableAddittionalCost";
import { IconButton } from "@mui/material";

const schema = yup.object().shape({});

const AdditionalCost = () => {
  // Filter states
  const [billingUnitData, setBillingUnitData] = useState([]);
  const [bussinesUnitData, setBussinesUnitData] = useState([]);
  const [billingPeriodsData, setBillingPeriodsData] = useState([]);
  const [filteredBussinesUnits, setFilteredBussinesUnits] = useState([]);
  const [filteredBillingPeriods, setFilteredBillingPeriods] = useState([]);

  const { control, handleSubmit, reset, watch, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const watchBillingUnit = watch("billingUnit");
  const watchBussinessUnit = watch("bussinessUnit");
  const watchPeriod = watch("period");

  const getSelects = useCallback(() => {
    callApiAsync(
      () => getBillingSelect(),
      (data) => {
        setBillingUnitData(data.billingUnit);
        setBussinesUnitData(data.bussinesUnit);
        setBillingPeriodsData(data.billingPeriods);
      }
    );
  }, []);

  const clearFilters = useCallback(() => {
    reset({
      billingUnit: null,
      bussinessUnit: null,
      period: null,
    });

    setFilteredBussinesUnits([]);
    setFilteredBillingPeriods([]);
  }, [reset]);


  useEffect(() => {
    getSelects();
  }, [getSelects]);
  

  useEffect(() => {
    if (watchBillingUnit) {
      const filteredUnits = bussinesUnitData.filter(
        (unit) => String(unit.idBillingUnit) === String(watchBillingUnit)
      );
      setFilteredBussinesUnits(filteredUnits);
      setValue("bussinessUnit", "");
      setValue("period", "");
      setFilteredBillingPeriods([]);
    } else {
      setFilteredBussinesUnits([]);
      setFilteredBillingPeriods([]);
    }
  }, [watchBillingUnit]);

  useEffect(() => {
    if (watchBussinessUnit) {
      const filteredPeriods = billingPeriodsData.filter(
        (period) => String(period.businessUnitId) === String(watchBussinessUnit)
      );
      setFilteredBillingPeriods(filteredPeriods);
      setValue("period", "");
    } else {
      setFilteredBillingPeriods([]);
    }
  }, [watchBillingUnit, watchBussinessUnit]);

  const onSubmit = (formData) => {
    console.log("onSubmit-formData", formData);
  };

  return (
    <div>
      <h1>Costos Independientes</h1>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 3 }}>
              <SearchableSelectInput
                name="billingUnit"
                control={control}
                label="Unidad de facturación"
                options={billingUnitData ? billingUnitData : []}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <SearchableSelectInput
                name="bussinessUnit"
                control={control}
                label="Unidad de negocio"
                options={filteredBussinesUnits}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <SearchableSelectInput
                name="period"
                control={control}
                label="Periodo"
                options={filteredBillingPeriods}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2 }}>
              <div className="HContainer">
                <IconButton onClick={clearFilters} sx={{ ml: 1 }}>
                  <img
                    className="w-icon-25"
                    src={icons.clearFilter}
                    alt="icon"
                  />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </form>
        <div>
          <TableAddittionalCost
            billingPeriodId={watchPeriod}
            businessUnitId={watchBussinessUnit}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalCost;
